// extracted by mini-css-extract-plugin
export default {"container":"JumioPopup__container--Qqn","cta":"JumioPopup__cta--3cm","updateInformationPopup":"JumioPopup__updateInformationPopup--2qK","title":"JumioPopup__title--c3b"};